import { Auth } from "aws-amplify";
import * as Sentry from "@sentry/react";

export default async (path?: string): Promise<{ authorization: string }> => {
  try {
    const auth = await Auth.currentSession();

    if (auth) {
      const token = auth.getIdToken().getJwtToken();

      return { authorization: `Bearer ${token}` };
    } else {
      Sentry.captureException(new Error("You are not authorized to access this request"), { extra: { path } });
      throw { response: { data: { errors: [ { details: "You are not authorized to access this request" } ] } } };
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { path } });
    throw { response: { data: { errors: [ { details: "You are not authorized to access this request" } ] } } };
  }
};
